import React, { useEffect, useRef, useState } from "react";
import CardDocument from "../../../cards/CardDocument";
import { useForm } from "react-hook-form";
import { getTemporaryUrl } from "../../../../services/File/getTemporaryUrl";
import { toast } from "react-toastify";
import Modal from "../../Modal";
import Input from "../../../input/Input";
import FileInput from "../../../input/FileInput";
import { Button } from "primereact/button";

export const Documents = ({ documents, setDocuments, typeRegister, cpf, setCpf, proofResidence, setProofResidence, socialContract, setSocialContract }) => {
  const fileInputRef = useRef(null);
  const formFile = useForm();
  const errorsFile = formFile.formState.errors;

  const [doc, setDoc] = useState("");
  const [type, setType] = useState("");
  const [docSelected, setDocSelected] = useState("");
  const [fileVisible, setFileVisible] = useState(false);
  const [contDocuments, setContDocuments] = useState(1);
  const [inputRequireds, setInputRequireds] = useState([]);

  const handleInputRequireds = () => {
    if (localStorage.getItem("required_registerGeneral") === "true") {
      var auxRegisterGeneral = localStorage.getItem("registerGeneral");

      setInputRequireds(auxRegisterGeneral);
    }
  };

  const handleCardClick = (type) => {
    setDocSelected(type);
    fileInputRef.current.click();
  };

  const handleSubmitFile = async (data) => {
    setDocuments((prevDocuments) => [
      ...prevDocuments,
      {
        id: `doc${contDocuments}`,
        name: data.name,
        file: doc,
        path: type,
        type_file: `cadastro_geral`,
      },
    ]);

    setContDocuments(contDocuments + 1);
    formFile.reset();
    setFileVisible(false);
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const base64Data = event.target.result;
        resolve(reader.result);
        return base64Data;
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const photoUpload = async (e) => {
    // e.preventDefault();
    let files = e.target ? e.target.files : e.files;
    if (!files || files.length === 0) {
      return;
    }
    const file = files[0];
    try {
      const res = await readFileAsBase64(file);
      return res;
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  const handleFileChange = async (e) => {
    // console.log("selected", docSelected);
    const res = await photoUpload(e);
    // console.log(res);

    // if (isEdit) {
    //   const doc = documents.find((item) => item.id === selectedDocId);
    //   setDocuments(
    //     documents.map((d) => {
    //       if (d.id === doc.id) {
    //         //            // console.log(d);
    //         return {
    //           id: doc.id,
    //           name: doc.name,
    //           type_file: `cadastro_geral_${docSelected}`,
    //           file: res,
    //         };
    //       } else {
    //         return {
    //           id: d.id,
    //           name: d.name,
    //           type_file: d.type_file,
    //           ...(d.path || d.file ? { path: d.path, file: d.file } : {}),
    //         };
    //       }
    //     })
    //   );
    // } else {
    switch (docSelected) {
      case "cpf":
        setCpf(res);
        break;
      case "proof_residence":
        setProofResidence(res);
        break;
      case "social_contract":
        setSocialContract(res);
        break;
      default:
        break;
    }
    // }
  };

  const downloadDoc = async (id) => {
    const notification = toast.loading("Preparando seu download...");
    try {
      const response = await getTemporaryUrl(id);
      // console.log(response);

      const extractFileName = (url) => {
        const matches = url.match(/\/([^\/?#]+)[^\/]*$/);
        if (matches && matches.length > 1) {
          return matches[1];
        }
        return null;
      };

      const fileName = extractFileName(response.url);

      function downloadPDF(url) {
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobURL;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Erro ao fazer o download do PDF:", error);
          });
      }

      downloadPDF(response.url);

      toast.update(notification, {
        render: "Download concluído!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      return response.url;
    } catch (error) {
      // console.log(error);
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      return null;
    }
  };

  const deleteDoc = (id) => {
    const newDoc = documents.filter((item) => item.id !== id);
    setDocuments(newDoc);
  };

  useEffect(() => {
    handleInputRequireds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (documents && documents.length > 0) {
      setDocuments(documents);
    }
  }, [documents, setDocuments]);

  return (
    <>
      <div className="row mt-3">
        {inputRequireds?.includes("cpf") &&
          typeRegister === "fisica" &&
          !documents.some((doc) => doc.type_file === "cadastro_geral_cpf") &&
          !documents.some((doc) => doc.type_file === "cpf") && (
            <CardDocument
              description={"Adicionar CPF*"}
              descriptionCompleted={"CPF Adicionado"}
              type="add"
              completed={cpf !== ""}
              onClick={() => handleCardClick("cpf")}
            />
          )}
        {inputRequireds?.includes("proof_residence") &&
          !documents.some(
            (doc) => doc.type_file === "cadastro_geral_proof_residence"
          ) &&
          !documents.some((doc) => doc.type_file === "proof_residence") && (
            <CardDocument
              description={"Adicionar Comp. de Residência*"}
              descriptionCompleted={"Comp. de Residência Adicionado"}
              type="add"
              completed={proofResidence !== ""}
              onClick={() => handleCardClick("proof_residence")}
            />
          )}
        {inputRequireds?.includes("social_contract") &&
          typeRegister === "juridica" &&
          !documents.some(
            (doc) => doc.type_file === "cadastro_geral_social_contract"
          ) &&
          !documents.some((doc) => doc.type_file === "social_contract") && (
            <CardDocument
              description={"Adicionar Contrato Social*"}
              descriptionCompleted={"Contrato Social Adicionado"}
              type="add"
              completed={socialContract !== ""}
              onClick={() => handleCardClick("social_contract")}
            />
          )}
        {documents &&
          documents.map((d, index) => {
            if (
              d.type_file === "cadastro_geral_profile_photo" ||
              d.type_file === "profile_photo"
            ) {
              return <></>;
            }

            return (
              <CardDocument
                key={index}
                idDoc={d.id}
                deleteFunction={deleteDoc}
                downloadFunction={() => downloadDoc(d.id)}
                hasLink={typeof d.id === "number"}
                // editFunction={() =>
                //   handleEditDocument(
                //     d.id,
                //     d.type_file.replace("cadastro_geral_", "")
                //   )
                // }
                requiredComplete={inputRequireds?.includes(
                  d.type_file.replace("cadastro_geral_", "")
                )}
                description={d.name}
                actions={true}
                type={d.path?.split(".").pop().toLowerCase()}
              />
            );
          })}
        <CardDocument
          description={"Adicionar Documento"}
          type="add"
          onClick={() => setFileVisible(true)}
        />
      </div>

      <Modal
        visible={fileVisible}
        position="center"
        onHide={() => setFileVisible(false)}
        dynamicTitle="Anexar arquivo"
      >
        <form onSubmit={formFile.handleSubmit(handleSubmitFile)}>
          <Input
            errors={errorsFile}
            control={formFile.control}
            name="name"
            label="Nome do Arquivo"
            className={"mb-5"}
            isRequired={true}
          />
          <FileInput
            doc="Arquivo"
            name="archive"
            icon="fa-file"
            base64={true}
            setType={setType}
            setSelectedFile={setDoc}
          />
          <div className="d-flex justify-content-end mt-4">
            <Button
              type="button"
              label="Cancelar"
              icon="pi pi-times"
              onClick={() => setFileVisible(false)}
              className="p-button-text"
            />
            <Button
              label="Criar"
              icon="pi pi-check"
              type="submit"
              // loading={loading}
              autoFocus
            />
          </div>
        </form>
      </Modal>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    </>
  );
};

export default Documents;
